import { render, staticRenderFns } from "./liveRewardOrder.vue?vue&type=template&id=5d6ae07c"
import script from "./liveRewardOrder.vue?vue&type=script&lang=js"
export * from "./liveRewardOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports